import { Component, Input } from '@angular/core';
import { EntityArt } from '@enums/entityArt.enum';


@Component({
    selector: 'cz-wiedervorlagen-popup',
    templateUrl: 'wiedervorlagen-popup.component.html',
    styleUrls: ['./wiedervorlagen-popup.component.css'],
    standalone: false
})
export class WiedervorlagenPopupComponent {

    popupVisible: boolean;

    @Input() ownerId: number;
    @Input() entityArt: EntityArt;

    loading = false;

    constructor() {
        this.hidePopup = this.hidePopup.bind(this);
    }

    showPopup() {
        this.popupVisible = true;
    }

    hidePopup() {
        this.popupVisible = false;
    }

}
